module.exports = __webpack_public_path__ + "static/bernardo-d34972bd4cb36e77dc3505cae177a7b0.jpg";